import {
    WorkflowTemplate,
    FormattedWorkflowTemplate
} from "@idw-types/data/reference-data/generic";
import { AxnCompany } from "@idw-types/data/reference-data/axn";

export const formatWorkflowTemplates = (
    workflowTemplates: Array<WorkflowTemplate>,
    axnCompanies: Array<AxnCompany>
): Array<FormattedWorkflowTemplate> => {
    return workflowTemplates.map(template => formatWorkflowTemplate(template, axnCompanies));
};

export const formatWorkflowTemplate = (
    workflowTemplate: WorkflowTemplate,
    axnCompanies: Array<AxnCompany>
): FormattedWorkflowTemplate => {
    const organization = axnCompanies.find(company => company.id === workflowTemplate.organizationID);

    return {
        id: workflowTemplate.id,
        description: workflowTemplate.description,
        descriptionURL: workflowTemplate.descriptionURL,
        name: workflowTemplate.name,
        organization: organization,
        status: workflowTemplate.status
    };
};